import { render, staticRenderFns } from "./AffiliateFilters.vue?vue&type=template&id=63060b77&scoped=true"
import script from "./AffiliateFilters.vue?vue&type=script&lang=js"
export * from "./AffiliateFilters.vue?vue&type=script&lang=js"
import style0 from "./AffiliateFilters.vue?vue&type=style&index=0&id=63060b77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63060b77",
  null
  
)

export default component.exports